export const EVALUATION_CRITERIA = {
  EC1: 1,
  EC2: 2,
  EC3: 3,
  EC4: 4,
  EC5: 5,
  EC6: 6,
  EC7: 7,
  EC8: 8,
  EC9: 9,
} as const;

export const SUB_CRITERIA = {
  SC14: 14,
} as const;

export function isEC1(ecNumber: number): boolean {
  return ecNumber === EVALUATION_CRITERIA.EC1;
}

export function isEC3(ecNumber: number): boolean {
  return ecNumber === EVALUATION_CRITERIA.EC3;
}

export function isEC8(ecNumber: number): boolean {
  return ecNumber === EVALUATION_CRITERIA.EC8;
}

export function isEC9(ecNumber: number): boolean {
  return ecNumber === EVALUATION_CRITERIA.EC9;
}

export function isSC14(scNumber: number): boolean {
  return scNumber === SUB_CRITERIA.SC14;
}
